<template>
  <div id="app">
    <div v-if="authenticated">
      <nav-bar/>
    </div>
    <router-view/>
    <FlashMessage :position="'left bottom'"></FlashMessage>
  </div>
</template>

<script>
import NavBar from '@/components/NavBar'

import { mapGetters } from 'vuex'

export default {
  name: 'App',
  components: {
    NavBar
  },
  created: function () {
    if (localStorage.getItem('settings')) {
      this.$store.dispatch('LOAD_SETTINGS', JSON.parse(localStorage.getItem('settings')))
    } else {
      this.$store.dispatch('LOAD_SETTINGS', {})
    }
  },
  computed: {
    ...mapGetters([
      'authenticated',
      'contracts',
      'groups'
    ])
  },
  watch: {
    authenticated: function () {
      if (this.authenticated) {
        this.$store.dispatch('GET_CONTRACTS', this)
      }
    },
    '$route.params.id': {
      handler: function () {
        if (this.$route.params.id) {
          this.$store.dispatch('SET_ACTIVE', this.$route.params.id)
        }
      },
      immediate: true
    }
  }
}

</script>

<style>
html {
  background: #ffffff;
  overflow-x: hidden;
}

body {
  background: #ffffff;
  font-family: 'Montserrat';

}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 50px;
}

.selected-row {
  background-color: #f4f5f8;
}

.highlight-row-red {
  background-color: rgba(206, 75, 75, 0.2);
}
.highlight-row-green {
  background-color: rgba(38, 169, 38, 0.1);
}
.highlight-row-amber {
  background-color: rgba(230, 145, 0, 0.12);
}
.stale-row {
  color: #9aa0a6;
  font-style: italic;
}

.btn-primary, .btn-primary:hover, .btn-primary:active, .btn-primary:visited {
  background-color: #70A1F0 !important;
  border-color: #70A1F0 !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue